import React from "react";

import { Spacer } from "../Grid/Spacer";
import { Icon } from "../Icon";
import { Text } from "../Text";

import { TagType } from "./types";

export function CardTagLabel({
  text,
  textProps = {
    size: "extraSmall",
    paragraph: true,
  },
  icon,
}: TagType) {
  return (
    <>
      {icon && (
        <>
          <Icon icon={icon} />
          <Spacer orientation="horizontal" size="tiny" />
        </>
      )}
      <Text {...textProps}>{text}</Text>
    </>
  );
}
